function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShowMore = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.572 4.004A2 2 0 1 1 8.573.003a2 2 0 0 1-.001 4.001m2 4.5a2 2 0 1 0-4.001.002 2 2 0 0 0 4.001-.002m0 6.5a2 2 0 1 0-4.001.002 2 2 0 0 0 4.001-.002",
    style: {
      fill: "#000"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShowMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/show-more.svg";